export const Sky = {
    sunny: '#87CEEB',        // Light blue sky for sunny weather
    partlyCloudy: '#ADD8E6', // Slightly muted blue for partly cloudy
    cloudy: '#B0C4DE',       // Light gray-blue for cloudy weather
    foggy: '#D3D3D3',        // Light gray for fog
    rainy: '#4A5D6B',        // Slate gray for rainy weather
    thunderstorm: '#4F4F4F', // Dark gray for thunderstorm
    night: '#191970',        // Dark navy blue for night
    snowy: '#4E5C6A',        // Very light blue/white for snowy weather
};

const uselessThing = 25252;